// extracted by mini-css-extract-plugin
var _1 = "header__eiQdr";
export { _1 as "header" }
